import { useTranslation } from "react-i18next";
import { clearAlerts, setListMessage, setErrorAlert } from './../../../config/redux/alerts/alertsActions';
import { useDispatch, RootStateOrAny, useSelector } from "react-redux";
import { FormikValues } from "formik";

import {
  setAdmin,
  addNewAdmin,
  toggleAdminsPanel,
} from "../../../config/redux/admins/adminsActions";
import { addAdmin, editAdmin} from "../../../connectors/admins/connectors/index";
import {IAdmin} from "../../../connectors/admins/models/index"
import { IResetForm } from "../../common/models/resetForm.type";
import { useState } from "react";

export const useAdminForm = () => {
  const [loading, setIsLoading] = useState(false)
  const { selectedAdmins, activeAdmin } = useSelector(
    (state: RootStateOrAny) => state.admins
  );
  const [editedAdmin] = useState(() => selectedAdmins[0]);
  const dispatch = useDispatch();
  const { t } = useTranslation("admin");
  let initValues = {
    firstName: "",
    lastName: "",
    phone: "",
    phoneNumber: "",
    email: "",
  };

  if (editedAdmin) {
    initValues = {
      firstName: editedAdmin.firstName,
      lastName: editedAdmin.lastName,
      phone: editedAdmin.phone,
      email: editedAdmin.email,
      phoneNumber: editedAdmin.phone,
    };
  }

  const add = async (data: IAdmin) => {
    const res = await addAdmin(data);
  };

  const edit = async (data: IAdmin) => {
    data.phoneNumber = data.phone;
    await editAdmin(data, editedAdmin.id);
  };

  const handleSubmit = async (
    values: FormikValues,
    { resetForm }: IResetForm
  ) => {
    setIsLoading(true)
    const body = {
      email: values.email,
      firstName: values.firstName,
      lastName: values.lastName,
      phone: values.phone,
      phoneNumber: values.phone,
    };
    try {
      dispatch(clearAlerts())
      editedAdmin ? await edit(body) : await add(body);
      setIsLoading(false)
      dispatch(setAdmin({}));
      dispatch(addNewAdmin({ add: true }));
      resetForm();
      dispatch(toggleAdminsPanel({ open: false }));
      dispatch(setListMessage(t("nav.operationSuccess") as string))
    } catch (err) {
      setIsLoading(false)
      dispatch(setErrorAlert(t("nav.operationError") as string))
    }
  };

  const cancelForm = () => {
    dispatch(toggleAdminsPanel({ open: false }));
    dispatch(clearAlerts())
  };

  return {
    handleSubmit,
    initValues,
    cancelForm,
    editedAdmin,
    loading
  };
};
